import React, {useEffect, useState} from 'react';
import Axios from 'axios';
import { Modal } from 'react-bootstrap';
import '../App.css';
import { useNavigate } from "react-router-dom";
import { Alert } from 'react-bootstrap';

function Grillabeneficiarios (props){
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const [show1, setShow1] = useState(false)
    const [datos, setDatos] = useState([]);
    const [datosBackup, setDatosBackup] = useState([])
    const [idbeneficiario, setIdBeneficiario] = useState('')
    const [listaEstados, setListaEstados] = useState('')
    const [listaEstados1, setListaEstados1] = useState('')
    const [listaEstados2, setListaEstados2] = useState('')
    const [rut, setRut] = useState('')
    const [primer_nombre, setprimer_nombre] = useState('')
    const [segundo_nombre, setsegundo_nombre] = useState('')
    const [primer_apellido, setprimer_apellido] = useState('')
    const [segundo_apellido, setsegundo_apellido] = useState('')
    const [rut1, setRut1] = useState('')
    const [primer_nombre1, setprimer_nombre1] = useState('')
    const [segundo_nombre1, setsegundo_nombre1] = useState('')
    const [primer_apellido1, setprimer_apellido1] = useState('')
    const [segundo_apellido1, setsegundo_apellido1] = useState('')

    const [tituloAlert, setTituloAlert] = useState('')
    const [textoAlert, setTextoAlert] = useState('')
    const [claseAlert, setClaseAlert] = useState('')
    const [alert, setAlert] = useState(false);
    const [classWaitProcess, setClassWaitProcess] = useState('waitProcess')    

    let statuscall = '' 

    const dataList = Array.isArray(datos) && datos.length > 0
    ? datos.map((item, i) => (
        <div key={i} className="bg-gray-200 p-6 rounded-lg shadow-md mt-6">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Detalle de beneficiario</h3>
        
        {/* Contenedor con grid de 4 columnas, en pantallas grandes */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        
        {/* Columna 1 */}
        <div className="space-y-2">
            {/* Número de Índice - destacado */}
            <div className="flex justify-end">
            <span className="bg-indigo-600 text-white px-3 py-1 rounded-lg text-xl font-bold">Nº{i + 1}</span>
            </div>
        </div>

        {/* Columna 2 */}
        <div className="space-y-2">
            {/* Nombres */}
            <div className="flex justify-start">
            <span className="font-medium text-gray-500">Nombres:</span>
            <span className="font-semibold text-gray-800">{item.primer_nombre} {item.segundo_nombre}</span>
            </div>

            {/* Apellidos */}
            <div className="flex justify-start">
            <span className="font-medium text-gray-500">Apellidos</span>
            <span className="font-semibold text-gray-800">{item.primer_apellido} {item.segundo_apellido}</span>
            </div>

            {/* Estado Beneficiario */}
            <div className="flex justify-start">
            <span className="font-medium text-gray-500">Estado beneficiario:</span>
            <span className="font-semibold text-gray-800">{item.estado}</span>
            </div>
        </div>

        {/* Columna 3 */}
        <div className="space-y-2">
            {/* Valor Ticket */}
            <div className="flex justify-start">
            <span className="font-semibold text-gray-800"><button className="w-full bg-indigo-600 text-white p-2 text-sm rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 flex items-center justify-center space-x-2" onClick={() => modificarBeneficiario(item)}>Modificar</button></span>
            </div>
        </div>
        </div>
    </div>))
    : (
      // opcional: fila vacía o mensaje cuando no hay datos
      <tr>
        <td className="px-6 py-4 text-sm text-gray-500" colSpan={7}>
          Sin resultados
        </td>
      </tr>
    );


    useEffect(() => {
        let mailstr = window.localStorage.getItem('MY_APP_STATE_USER').replace('"', '')
        let idperfilstr = window.localStorage.getItem('MY_APP_STATE_PROF_ID').replace('"', '')
        let idcasinostr = window.localStorage.getItem('MY_APP_STATE_PROF_CASINO_ID').replace('"', '')
        
        let mail = mailstr.replace('"', '')
        let idperfil = idperfilstr.replace('"', '')
        let idcasino = idcasinostr.replace('"', '')
        
        Axios.get(process.env.REACT_APP_DATAUSER, {
            params: {
                mail: mail,
                id_perfil: idperfil,
                id_casino: idcasino,
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setDatos(response.data.beneficiarios)
            setDatosBackup(response.data.beneficiarios)
        }).catch(error => {
            return error     
        });
    }, []);

    const modificarBeneficiario= (item) =>{
        setListaEstados(item.state_beneficiary_id)
        setIdBeneficiario(item.id)
        setRut1(item.rut)
        setprimer_nombre1(item.primer_nombre)
        setsegundo_nombre1(item.segundo_nombre)
        setprimer_apellido1(item.primer_apellido)
        setsegundo_apellido1(item.segundo_apellido)
        handleShow1()
    }

    const handleClose = () => setShow(false)
    const handleShow = () => setShow(true)
    const handleClose1 = () => setShow1(false)
    const handleShow1 = () => setShow1(true)

    const handleChangeList= (e) => {
        let text = e.target.value;
        const setBusqueda = e.target.value;
        console.log("Busqueda: " + e.target.value)
        const data = datosBackup
        const newData = data.filter(
            function(item){
                const itemDataNombre = item.primer_nombre.toUpperCase()
                const itemDataApellido = item.primer_apellido.toUpperCase()
                const itemSegundoApellido = item.segundo_apellido.toUpperCase()      
                const campo = itemDataNombre +" "+itemDataApellido+" "+itemSegundoApellido
                const textData = text.toUpperCase()
                return campo.indexOf(textData) > -1        
            }
        )
        setDatos(newData)
    }

    const handlerChangeEstados= (e) =>{
        setListaEstados(e.target.value)
    }
    const createBenefificiario = async (e) =>{
        setClassWaitProcess('waitProcessV')
        if(rut !='')
        {
            if(primer_nombre != '')
            {
                if(primer_apellido != '')
                {
                    let mailstr = window.localStorage.getItem('MY_APP_STATE_USER').replace('"', '')
                    let authcode = window.localStorage.getItem('MY_APP_STATE_AUTHCODE').replace('"', '')
                    const data = {   
                        rut: rut,    
                        primer_nombre: primer_nombre,
                        segundo_nombre: segundo_nombre1,
                        primmer_apellido: primer_apellido,
                        segundo_apellido: segundo_apellido,
                        mail: mailstr.replace('"','')
                    };
            
                    const beneficiarioCreate = await Axios.post(process.env.REACT_APP_CREATEBENEF, data, {
                        timeout: process.env.REACT_APP_TIMEOUT,
                        headers: {
                            'Access-Control-Allow-Origin' : '*',
                            'Access-Control-Allow-Methods': 'GET, POST',
                            'Access-Control-Allow-Headers': 'Content-Type'
                        }}).then(res => statuscall = res).catch(err => statuscall = err.response);
                            
                        if(statuscall.status == 200)
                        {
                            if(statuscall.data.MessageCode == '0')
                            {
                                datos.push(data);
                                let copibenef = datos 
                                setDatos(copibenef)
                                setClassWaitProcess('waitProcess')
                                setTituloAlert('Creacion de beneficiarios')
                                setTextoAlert('Beneficiario creado')
                                setClaseAlert('success alertFlotante opacity-100')
                                setAlert(true)
                                setTimeout(() => {    
                                    setAlert(false)
                                    navigate('/Home/' + authcode.replace('"', ''))
                                }, 3000)
            
                                setTimeout(() =>{
                                    handleClose()
                                }, 3500)
                            }
                            else
                            {
                                setClassWaitProcess('waitProcess')
                                setTituloAlert('Creacion de beneficiarios')
                                setTextoAlert(statuscall.data.Message)
                                setClaseAlert('danger alertFlotante opacity-100')
                                setAlert(true)
                                setTimeout(() => {
                                    setAlert(false)
                                }, 3500)
                            }                            
                        }
                        else
                        {
                            setClassWaitProcess('waitProcess')
                            setTituloAlert('Creacion de beneficiarios')
                            setTextoAlert('Servidor no responde. Intentelo mas tarde')
                            setClaseAlert('danger alertFlotante opacity-100')
                            setAlert(true)
                            setTimeout(() => {
                                setAlert(false)
                            }, 3500)             
                        }
                }
                else
                {
                    setClassWaitProcess('waitProcess')
                    setTituloAlert('Creacion de beneficiarios')
                    setTextoAlert('Debe ingresar primer apellido')
                    setClaseAlert('warning alertFlotante opacity-100')
                    setAlert(true)
                    setTimeout(() => {
                        setAlert(false)
                    }, 3500)
                }
            }
            else
            {
                setClassWaitProcess('waitProcess')
                setTituloAlert('Creacion de beneficiarios')
                setTextoAlert('Debe ingresar primer nombre')
                setClaseAlert('warning alertFlotante opacity-100')
                setAlert(true)
                setTimeout(() => {
                    setAlert(false)
                }, 3500)
            }
        }
        else
        {
            setClassWaitProcess('waitProcess')
            setTituloAlert('Creacion de beneficiarios')
            setTextoAlert('Debe ingresar rut')
            setClaseAlert('warning alertFlotante opacity-100')
            setAlert(true)
            setTimeout(() => {
                setAlert(false)
            }, 3500)
        }

      
    }

    const handleChangeRut=(e) =>{
        // Despejar Puntos
        let valor = e.target.value.replace('.','');
        // Despejar Guión
        valor = valor.replace('-','');
        
        // Aislar Cuerpo y Dígito Verificador
        let cuerpo = valor.slice(0,-1);
        let dv = valor.slice(-1).toUpperCase();
    
        // Formatear RUN
        setRut(cuerpo + '-'+ dv)
    }

    const handleChangeRut1=(e) =>{
        // Despejar Puntos
        let valor = e.target.value.replace('.','');
        // Despejar Guión
        valor = valor.replace('-','');
        
        // Aislar Cuerpo y Dígito Verificador
        let cuerpo = valor.slice(0,-1);
        let dv = valor.slice(-1).toUpperCase();
    
        // Formatear RUN
        setRut1(cuerpo + '-'+ dv)
    }    
    
    const handleChangeprimernombre= (e) => {
        setprimer_nombre(e.target.value)
    }

    const handleChangesegundonombre= (e) => {
        setsegundo_nombre(e.target.value)
    }    

    const handleChangeprimerapellido= (e) => {
        setprimer_apellido(e.target.value)
    }    

    const handleChangesegundoapellido= (e) => {
        setsegundo_apellido(e.target.value)
    }

    const handleChangeprimernombre1= (e) => {
        setprimer_nombre1(e.target.value)
    }

    const handleChangesegundonombre1= (e) => {
        setsegundo_nombre1(e.target.value)
    }    

    const handleChangeprimerapellido1= (e) => {
        setprimer_apellido1(e.target.value)
    }    

    const handleChangesegundoapellido1= (e) => {
        setsegundo_apellido1(e.target.value)
    }

    const handleEstadoBenef = (id) => {
       
    }

    const putBeneficiario = async () =>{
        setClassWaitProcess('waitProcessV') 
        if(rut1 != '')
        {
            if(primer_nombre1 != '')
            {
                if(primer_apellido1 != '')
                {

                    let urlput = process.env.REACT_APP_URLPUTBENEFICIARIO+idbeneficiario+'/update'
                    let authcode = window.localStorage.getItem('MY_APP_STATE_AUTHCODE').replace('"', '')
                    const data = {   
                        rut: rut1,
                        primer_nombre: primer_nombre1,
                        segundo_nombre: segundo_nombre1,
                        primer_apellido: primer_apellido1,
                        segundo_apellido: segundo_apellido1,
                        state_beneficiary_id: listaEstados
                    }
            
                    const casinoPut = await Axios.put(urlput, data, {
                        timeout: process.env.REACT_APP_TIMEOUT,
                        headers: {
                            'Access-Control-Allow-Origin' : '*',
                            'Access-Control-Allow-Methods': 'GET, POST',
                            'Access-Control-Allow-Headers': 'Content-Type'
                    }}).then(res => statuscall = res).catch(err => statuscall = err.response);
                        
                    if(statuscall.status == 200)
                    {   
                        setClassWaitProcess('waitProcess')
                        setTituloAlert('Modificación de beneficiarios')
                        setTextoAlert('Beneficiario actualizado')
                        setClaseAlert('success alertFlotante opacity-100')
                        setAlert(true)
                        setTimeout(() => {
                            setAlert(false)
                        }, 3000)
    
                        setTimeout(() =>{
                            handleClose1()
                        }, 3500)
                    }
                    else
                    {
                        if(statuscall.status == 0)
                        {
                            setClassWaitProcess('waitProcess')
                            setTituloAlert('Modificación de beneficiarios')
                            setTextoAlert('Servidor no responde. Intentelo mas tarde')
                            setClaseAlert('danger alertFlotante opacity-100')
                            setAlert(true)
                            setTimeout(() => {
                                setAlert(false)
                            }, 4000)                        
                        }
                    }
                }
                else
                {
                    setClassWaitProcess('waitProcess')
                    setTituloAlert('Modifacion de beneficiarios')
                    setTextoAlert('Debe ingresar primer apellido')
                    setClaseAlert('warning alertFlotante opacity-100')
                    setAlert(true)
                    setTimeout(() => {
                        setAlert(false)
                    }, 4000)
                }
            }
            else
            {
                setClassWaitProcess('waitProcess')
                setTituloAlert('Modificación de beneficiarios')
                setTextoAlert('Debe ingresar primer nombre')
                setClaseAlert('warning alertFlotante opacity-100')
                setAlert(true)
                setTimeout(() => {
                    setAlert(false)
                }, 4000)
            }
        }
        else
        {
            setClassWaitProcess('waitProcess')
            setTituloAlert('Modificación de beneficiarios')
            setTextoAlert('Debe ingresar rut')
            setClaseAlert('warning alertFlotante opacity-100')
            setAlert(true)
            setTimeout(() => {
                setAlert(false)
            }, 4000)
        }
    }    


    return(
    <div className='w-full'>
        <div className="bg-white shadow-lg p-6 mx-4 mb-2">
            <h2 className="text-xl font-semibold mb-4">Lista de beneficiarios</h2>
        </div>

        {/* Zona 2 */}
        <div className="bg-white shadow-lg p-4 mx-4 mb-2">
            {/* Controles de Búsqueda y Exportar */}
            <div className="flex justify-between items-center mb-4">
                        {/* Campo de Búsqueda */}
                        <div className="flex flex-col col-span-1 sm:col-span-2 lg:col-span-1">
                            
                            <div className="flex items-center bg-gray-100 border border-gray-300 rounded-lg">
                            <input 
                                type="search" 
                                id="search"
                                onChange={handleChangeList} 
                                placeholder="Buscar en grilla" 
                                className="p-2 text-sm bg-transparent border-0 outline-none flex-1 rounded-l-lg focus:ring-0" 
                            />
                            <button className="p-2 text-gray-500 bg-transparent rounded-r-lg hover:bg-gray-200">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="h-5 w-5">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm0 0l5 5" />
                                </svg>
                            </button>
                            </div>
                        </div>
            </div>
            <div className="overflow-y-auto h-[300px] p-4">
                {/* Contenedor para los detalles de los tickets */}
                <div className="space-y-6">
                    {dataList}
                </div>
            </div>
        </div>        

        <div className="bg-white shadow-lg p-6 mx-4 mb-2">
            <button className="w-full bg-indigo-600 text-white p-2 text-sm rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 flex items-center justify-center space-x-2" onClick={handleShow}> + Agregar Beneficiario</button>
        </div>


  

        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Crear beneficiario</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={classWaitProcess}>
                    <div className='loaderS divAbsolute'>
                    </div>
                </div>

                <div className='row divAbsolute'>
                    <div className='col col-lg-12'>
                        {alert
                        ?<Alert variant={claseAlert} onClose={() => setAlert(false)} dismissible fade show>
                            <Alert.Heading>{tituloAlert}</Alert.Heading>
                                <p>
                                    {textoAlert}
                                </p>
                        </Alert>
                        :''
                        }
                    </div>
                </div>

                <div className="container mx-auto p-6">
                    <form className="space-y-6">
                        
                        
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <label className="text-gray-700 font-medium" htmlFor="rut">Rut</label>
                        <input 
                            type="text" 
                            id="rut"
                            value={rut}
                            onChange={handleChangeRut} 
                            className="p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                        </div>

                        
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <label className="text-gray-700 font-medium" htmlFor="primerNombre">Primer Nombre</label>
                        <input 
                            type="text" 
                            id="primerNombre"
                            onChange={handleChangeprimernombre} 
                            className="p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                        </div>

                        
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <label className="text-gray-700 font-medium" htmlFor="segundoNombre">Segundo Nombre</label>
                        <input 
                            type="text" 
                            id="segundoNombre"
                            onChange={handleChangesegundonombre} 
                            className="p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                        </div>

                        
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <label className="text-gray-700 font-medium" htmlFor="primerApellido">Primer Apellido</label>
                        <input 
                            type="text" 
                            id="primerApellido"
                            onChange={handleChangeprimerapellido} 
                            className="p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                        </div>

                        
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <label className="text-gray-700 font-medium" htmlFor="segundoApellido">Segundo Apellido</label>
                        <input 
                            type="text" 
                            id="segundoApellido"
                            onChange={handleChangesegundoapellido} 
                            className="p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                        </div>                        
                    </form>
                </div>

                        
            </Modal.Body>
            <Modal.Footer>
                <button className='bg-indigo-600 text-white py-2 px-4 rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500' onClick={handleClose}>
                    Cerrar
                </button>
                <button className='bg-indigo-600 text-white py-2 px-4 rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500' onClick={createBenefificiario}>
                    Crear
                </button>
                </Modal.Footer>
        </Modal>

        <Modal show={show1} onHide={handleClose1} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Modificar beneficiario</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={classWaitProcess}>
                    <div className='loaderS divAbsolute'>
                    </div>
                </div>

                <div className='row divAbsolute'>
                    <div className='col col-lg-12'>
                        {alert
                        ?<Alert variant={claseAlert} onClose={() => setAlert(false)} dismissible fade show>
                            <Alert.Heading>{tituloAlert}</Alert.Heading>
                                <p>
                                    {textoAlert}
                                </p>
                        </Alert>
                        :''
                        }
                    </div>
                </div>

                <div className="container mx-auto p-6">
                    <form className="space-y-6">


                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <label className="text-gray-700 font-medium" htmlFor="rut1">Rut</label>
                        <input 
                            type="text" 
                            id="rut1"
                            value={rut1}
                            onChange={handleChangeRut1} 
                            className="p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                        </div>


                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <label className="text-gray-700 font-medium" htmlFor="primer_nombre1">Primer Nombre</label>
                        <input 
                            type="text" 
                            id="primer_nombre1"
                            value={primer_nombre1}
                            onChange={handleChangeprimernombre1} 
                            className="p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                        </div>


                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <label className="text-gray-700 font-medium" htmlFor="segundo_nombre1">Segundo Nombre</label>
                        <input 
                            type="text" 
                            id="segundo_nombre1"
                            value={segundo_nombre1}
                            onChange={handleChangesegundonombre1} 
                            className="p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                        </div>


                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <label className="text-gray-700 font-medium" htmlFor="primer_apellido1">Primer Apellido</label>
                        <input 
                            type="text" 
                            id="primer_apellido1"
                            value={primer_apellido1}
                            onChange={handleChangeprimerapellido1} 
                            className="p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                        </div>


                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <label className="text-gray-700 font-medium" htmlFor="segundo_apellido1">Segundo Apellido</label>
                        <input 
                            type="text" 
                            id="segundo_apellido1"
                            value={segundo_apellido1}
                            onChange={handleChangesegundoapellido1} 
                            className="p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                        </div>


                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <label className="text-gray-700 font-medium" htmlFor="estado">Estado</label>
                        <select 
                            id="estado"
                            value={listaEstados}
                            onChange={handlerChangeEstados} 
                            className="p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                            <option value="2">Inactivo</option>
                            <option value="1">Activo</option>
                            <option value="3">Pendiente de activación</option>
                        </select>
                        </div>
                    </form>
                    </div>
   
            </Modal.Body>
            <Modal.Footer>
                <button className='bg-indigo-600 text-white py-2 px-4 rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500' onClick={handleClose1}>
                    Cerrar
                </button>
                <button className='bg-indigo-600 text-white py-2 px-4 rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500' onClick={putBeneficiario}>
                    Modificar
                </button>
                </Modal.Footer>
        </Modal>                                                                                                                                                                                                                   
    </div>    
    )
}
export default Grillabeneficiarios